import { cn as packageCn, en as packageEn, jp as packageJp, tw as packageTw } from '@patsnap-biz/user-package-tags';

const cn = {
    commonProductPackage: packageCn.UserPackageTags,
};

const en = {
    commonProductPackage: packageEn.UserPackageTags,
};

const tw = {
    commonProductPackage: packageTw.UserPackageTags,
};

const jp = {
    commonProductPackage: packageJp.UserPackageTags,
};

const messages = {
    cn, en, tw, jp,
};

export default messages;
